import { __rest } from "tslib";
import React, { useState } from 'react';
import classnames from 'classnames';
import * as styles from './base.scss';
import { alignmiddle } from '../../../styles/objects/icon.scss';
import { translate } from 'Shared/translate';
import EsalesFacetCategory from './EsalesFacetCategory';
import CampaignCategory from './CampaignCategory';
import Icon from 'Shared/Icon';
function isEsalesItem(item) {
    return 'ticket' in item;
}
function isEsalesType(items) {
    return items.some(isEsalesItem);
}
const CategoryFacet = (_a) => {
    var { subCategories } = _a, restProps = __rest(_a, ["subCategories"]);
    const [isOpen, setOpen] = useState(!!restProps.defaultOpen);
    const renderFacetTitle = () => {
        if (!!subCategories && isEsalesType(subCategories)) {
            return translate('/Facets/Department');
        }
        else {
            return translate('/Facets/Campaigns');
        }
    };
    return (!!subCategories &&
        subCategories.length > 0 && (React.createElement("li", { className: classnames(styles.facetGroup, { [styles.open]: isOpen }) },
        React.createElement("div", null,
            React.createElement("div", { className: styles.toggler, onClick: () => setOpen(!isOpen) },
                React.createElement("span", { className: alignmiddle },
                    React.createElement("span", { className: styles.title }, renderFacetTitle()),
                    React.createElement(Icon, { name: isOpen ? 'minus' : 'plus' }))),
            React.createElement("div", { className: classnames(styles.categoryList, { [styles.categoryListClosed]: !isOpen }) },
                React.createElement("ul", { className: styles.values }, isEsalesType(subCategories) ? (React.createElement(EsalesFacetCategory, Object.assign({ subCategories: subCategories }, restProps))) : (React.createElement(CampaignCategory, Object.assign({ subCategories: subCategories }, restProps)))))))));
};
export default CategoryFacet;
